import React, { useEffect, useState } from "react";
import Modal from "../../../common/modal/modal";
import PageHeader from "../../../common/pageheader/pageheader";
import { api } from "../../../../resources/api";
import Loader from "../../../common/loader/loader";
import { showAlert } from "../../../common/sweetalert/sweetalert";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import ReportTable from "../../../common/table/ReportTable";
import InventoryCategoryForm from "./inventory-category-form";
import InventorySubCategoryForm from "./inventory-sub-category-form";

function InventoryCategory(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [isFormLoading, setIsFormLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openModal2, setOpenModal2] = useState(false);
    const initialCategoryValue = { category_id: '', category_name: '', description: '', submitted_by: '', updated_by: '' }
    const initialSubCategoryValue = { sub_category_id: '', category_id: '', category_name: '', sub_category_name: '', description: '', submitted_by: '', updated_by: '' }
    const [formData, setFormData] = useState(initialCategoryValue);
    const [formData2, setFormData2] = useState(initialSubCategoryValue);

    const [categoryList, setCategoryList] = useState([]);
    const columns = ["S/N", "Action", "Category Name", "Description", "Inserted By"];
    const columns2 = ["S/N", "Action", "Category Name", "Sub Category Name", "Description", "Inserted By"];
    const [tableData, setTableData] = useState([]);
    const [tableData2, setTableData2] = useState([]);

    const fetchCategoryData = async () => {
        try {
            const { success, data } = await api.get("staff/inventory/category/data/list");
            if (success && data.message === 'success') {
                const categories = [];
                const sub_categories = [];

                if (data.Category.length > 0) {
                    data.Category.map((r, i) => {
                        categories.push([i + 1,
                        (
                            <button
                                className="btn btn-sm btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#kt_modal_general"
                                onClick={() => {
                                    setFormData({
                                        ...formData,
                                        category_name: r.category_name,
                                        description: r.description,
                                        submitted_date: r.submitted_date,
                                        submitted_by: r.submitted_by,
                                        category_id: r.category_id,
                                    })
                                }
                                }
                            >
                                <i className="fa fa-pen" />
                            </button>
                        ),
                        r.category_name, r.description, r.InsertedBy
                        ])
                    })
                    setTableData(categories)
                }

                if (data.SubCategory.length > 0) {
                    data.SubCategory.map((r, i) => {
                        sub_categories.push([i + 1,
                        (
                            <button
                                className="btn btn-sm btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#sub_cat"
                                onClick={() => {
                                    onOpenModal2();
                                    setFormData2({
                                        ...formData2,
                                        category_id: r.category_id,
                                        category_name: r.category_name,
                                        sub_category_name: r.sub_category_name,
                                        description: r.description,
                                        submitted_date: r.submitted_date,
                                        submitted_by: r.submitted_by,
                                        sub_category_id: r.sub_category_id,
                                    })
                                }
                                }
                            >
                                <i className="fa fa-pen" />
                            </button>
                        ),
                        r.category_name, r.sub_category_name, r.description, r.InsertedBy
                        ])
                    })
                    setTableData2(sub_categories)
                }

                setCategoryList(data.Category)
            } else {
                toast.info("Something went wrong. Please try again!")
            }
            setIsLoading(false)
        } catch (e) {
            toast.error("NETWORK ERROR")
        }
    }

    useEffect(() => {
        fetchCategoryData()
    }, [formData])

    const onOpenModal = () => {
        setFormData(initialCategoryValue)
    }

    const onOpenModal2 = () => {
        setFormData2(initialSubCategoryValue)
    }
    const handleFormValueChange = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        })
    }
    const handleFormValueChange2 = (e) => {
        setFormData2({
            ...formData2,
            [e.target.id]: e.target.value
        })
    }

    const onFormSubmit = async (e) => {
        e.preventDefault();
        if (formData.category_name.toString().trim() === "") {
            toast.error("Please Enter the Category Name");
            return false;
        }
        setIsFormLoading(true)
        if (formData.category_id === '') {
            let sendData = {
                ...formData,
                submitted_by: props.loginData[0].StaffID
            }

            try {
                const { success, data } = await api.post("staff/inventory/category/add", sendData);
                if (success) {
                    if (data.message === "success") {
                        toast.success("Category Data Added Successfully");
                        fetchCategoryData();
                        setFormData({
                            ...formData,
                            ...initialCategoryValue
                        })
                        setIsFormLoading(false)
                        document.getElementById("closeModal").click();
                    } else if (data.message === "exist") {
                        setIsFormLoading(false)
                        showAlert("CATEGORY EXIST", "Category already exist!", "error");
                    } else {
                        setIsFormLoading(false)
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                }
            } catch (error) {
                setIsFormLoading(false)
                showAlert(
                    "NETWORK ERROR",
                    "Please check your connection and try again!",
                    "error"
                );
            }
        } else {
            let sendData = {
                ...formData,
                updated_by: props.loginData[0].StaffID
            }
            try {
                const { success, data } = await api.patch("staff/inventory/category/update", sendData);
                if (success) {
                    if (data.message === "success") {
                        toast.success("Category Data Updated Successfully");
                        fetchCategoryData();
                        setFormData({
                            ...formData,
                            ...initialCategoryValue
                        })
                        setIsFormLoading(false)
                        document.getElementById("closeModal").click();
                    } else {
                        setIsFormLoading(false)
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                }
            } catch (error) {
                setIsFormLoading(false)
                showAlert(
                    "NETWORK ERROR",
                    "Please check your connection and try again!",
                    "error"
                );
            }
        }

    }

    const onFormSubmit2 = async (e) => {
        e.preventDefault();
        if (formData2.category_id.toString().trim() === "") {
            toast.error("Please Select Category");
            return false;
        }

        if (formData2.sub_category_name.toString().trim() === "") {
            toast.error("Please Enter Sub Category Name");
            return false;
        }
        setIsFormLoading(true)
        if (formData2.sub_category_id === '') {
            let sendData = {
                ...formData2,
                submitted_by: props.loginData[0].StaffID
            }

            try {
                const { success, data } = await api.post("staff/inventory/sub_category/add", sendData);
                if (success) {
                    if (data.message === "success") {
                        toast.success("Sub Category Added Successfully");
                        fetchCategoryData();
                        setFormData2({
                            ...formData2,
                            ...initialSubCategoryValue
                        })
                        setIsFormLoading(false)
                        document.getElementById("closeModal").click();
                    } else if (data.message === "exist") {
                        setIsFormLoading(false)
                        showAlert("SUB CATEGORY EXIST", "Sub Category already exist!", "error");
                    } else {
                        setIsFormLoading(false)
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                }
            } catch (error) {
                setIsFormLoading(false)
                showAlert(
                    "NETWORK ERROR",
                    "Please check your connection and try again!",
                    "error"
                );
            }
        } else {
            let sendData = {
                ...formData2,
                updated_by: props.loginData[0].StaffID
            }
            try {
                const { success, data } = await api.patch("staff/inventory/sub_category/update", sendData);
                if (success) {
                    if (data.message === "success") {
                        toast.success("Category Data Updated Successfully");
                        fetchCategoryData();
                        setFormData2({
                            ...formData2,
                            ...initialSubCategoryValue
                        })
                        setIsFormLoading(false)
                        document.getElementById("closeModal").click();
                    } else {
                        setIsFormLoading(false)
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                }
            } catch (error) {
                setIsFormLoading(false)
                showAlert(
                    "NETWORK ERROR",
                    "Please check your connection and try again!",
                    "error"
                );
            }
        }

    }

    return isLoading ? (
        <Loader />
    ) : (
        <div className="d-flex flex-column flex-row-fluid">
            <PageHeader title={"Inventory Categories"} items={["Human Resources", "Inventory", "Inventory Categories"]} />
            <div className="flex-column-fluid">
                <div className="card card-no-border">
                    <div className="card-body p-0">
                        <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-8">

                            <li className="nav-item">
                                <a className="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#category">Category</a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link text-active-primary pb-4" data-kt-countup-tabs="true" data-bs-toggle="tab" href="#sub_category">Sub Category</a>
                            </li>
                        </ul>

                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade active show" id="category" role="tabpanel">
                                <div className="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
                                    <button
                                        type="button"
                                        className="btn btn-primary mb-3"
                                        data-bs-toggle="modal"
                                        data-bs-target="#kt_modal_general"
                                        onClick={() =>
                                            setFormData(initialCategoryValue)
                                        }
                                    >
                                        <i className="fa fa-plus me-2"></i>
                                        Add Category
                                    </button>
                                </div>
                                <ReportTable title={"Inventory Category"} columns={columns} data={tableData} />
                            </div>
                            <div className="tab-pane fade" id="sub_category" role="tabpanel">
                                <div className="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
                                    <button
                                        type="button"
                                        className="btn btn-primary mb-3"
                                        data-bs-toggle="modal"
                                        data-bs-target="#sub_cat"
                                        onClick={() => setFormData2(initialSubCategoryValue)
                                        }
                                    >
                                        <i className="fa fa-plus me-2"></i>
                                        Add Sub Category
                                    </button>
                                </div>
                                <ReportTable title={"Inventory Sub Category"} columns={columns2} data={tableData2} />
                            </div>
                        </div>
                    </div>
                </div>

                <Modal title={"Add Category"}>
                    <InventoryCategoryForm value={formData} isFormLoading={isFormLoading} onChange={handleFormValueChange} onSubmit={onFormSubmit} />
                </Modal>
                <Modal title={"Sub Category Form"} id="sub_cat">
                    <InventorySubCategoryForm value={formData2} categoryList={categoryList} isFormLoading={isFormLoading} onChange={handleFormValueChange2} onSubmit={onFormSubmit2} />
                </Modal>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};

export default connect(mapStateToProps, null)(InventoryCategory);